<template>
  <div fluid>
    <HeaderBar>
      <v-icon slot="icon">add</v-icon>
      Add Client User
    </HeaderBar>

    <v-layout row>
      <v-flex grow class="mr-2">
        <v-layout column>
          <v-layout row>
            <v-flex class="mr-2">
              <v-text-field
                v-model="firstName"
                label="First Name"
              ></v-text-field>
            </v-flex>
            <v-flex class="mr-2">
              <v-text-field
                v-model="lastName"
                label="Last Name"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex class="mr-2">
              <v-text-field
                v-model="email"
                label="Email (used as login)"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-layout>
        <v-layout>
          <v-flex>
            <v-autocomplete
              label="Location"
              :items="possibleLocations"
              item-text="name"
              item-value="id"
              hint="The client can manage shifts at the location chosen here."
              persistent-hint
              v-model="locationId"
            >
            </v-autocomplete>
          </v-flex>
        </v-layout>
      </v-flex>

      <v-flex shrink>
        <v-layout column>
          <v-flex>
            <v-btn @click="createClient()" block :disabled="!newClientValid" color="success">
              Save &amp; Create
            </v-btn>
          </v-flex>
          <v-flex>
            <v-btn to="/hr/clients" block color="error">
              Cancel
            </v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import HeaderBar from '@/components/base/header-bar.vue'
import collectionsApi from '@/api/collections'

export default {
  components: {
    HeaderBar,
  },
  created () {
    this.setUp()
  },
  watch: {
  },
  computed: {
    ...mapState('userAuth', [
      'user',
    ]),
    newClientValid () {
      if (
        this.firstName &&
        this.lastName &&
        this.email &&
        this.locationId) {
        return true
      }
      return false
    },
  },
  methods: {
    setUp () {
      this.getPossibleLocations()
      if (this.$route.query.worksiteId) {
        this.locationId = this.$route.query.worksiteId
      }
    },
    getPossibleLocations () {
      collectionsApi.getLocations(locations => {
        this.possibleLocations = locations
      })
    },
    createClient () {
      this.$store.dispatch('clients/create', {
        first_name: this.firstName,
        last_name: this.lastName,
        email: this.email,
        worksite_id: this.locationId,
      })
      .then(res => {
        const message = `Created client user ${ this.firstName } ${ this.lastName }!`
        this.$store.dispatch('global/showSnackbarSuccess', { message: message })
        this.$router.push({ name: 'clientDetail', params: { clientId: res.id } })
      })
      .catch(e => {
        const message = `Something went wrong creating that client...`
        this.$store.dispatch('global/showSnackbarError', { message: message })
      })
    },
  },
  data: function() {
    return {
      possibleLocations: [],
      firstName: '',
      lastName: '',
      email: '',
      locationId: ''
    }
  },
}
</script>

<style scoped>
#dashboard-container {
}
</style>
